import { TrackingType } from '../../../../Commerce/TrackingType.csharp';
import { getFor } from '../../../ReactComponents/API';
import { RecommendationsService } from '../../../Recommendations/ViewModels/RecommendationsService';
import { LocalStorageAccessor } from '../../../StorageAccessor/LocalStorageAccessor';
import { SessionStorageAccessor } from '../../../StorageAccessor/SessionStorageAccessor';
import { CacheStatus } from '../PersonalizedCart/CacheStatus.csharp';
import { PersonalizedCartViewModel } from '../PersonalizedCart/PersonalizedCartViewModel.csharp';
import { UserDetailsViewModel } from '../PersonalizedCart/UserDetailsViewModel.csharp';
import { CartViewModel } from '../ViewModels/CartViewModel.csharp';

export class CartAccessor {
    static getPersonalizedCart(cartUrl: string): Promise<{ cart: CartViewModel; user: UserDetailsViewModel }> {
        const cartString = SessionStorageAccessor.getItem('cart');
        LocalStorageAccessor.removeItem('cart');
        let cart = cartString ? (JSON.parse(cartString) as CartViewModel) : null;
        const version = cart != null ? cart.version : '';

        return getFor<PersonalizedCartViewModel>(`${cartUrl}?v=${version}`).then((result) => {
            if (result.cartStatus != CacheStatus.Validated) {
                cart = result.cart;

                if (cart?.items.length > 0) {
                    //if there was outdated version of cart we need to refresh also recommendations for cart drawer.
                    RecommendationsService.LoadRecommendations('basketWidget', TrackingType.Basket);
                }
            }

            return { cart: cart as CartViewModel, user: result.user };
        });
    }

    static cacheCart(cart: CartViewModel) {
        SessionStorageAccessor.setItem('cart', JSON.stringify(cart));
    }
}
